import { WalletService } from './services/wallet.service';
import { PollPdfService } from './services/poll-pdf.service';
import { CompanyService } from './services/company.service';
import { ReportPerformService } from './services/report-perform.service';
import { InvitePerformService } from './services/inviteperform.service';
import { PerformService } from './services/perform.service';
import { InvitePollService } from './services/invitepoll.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpModule, Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig  } from 'angular2-jwt';
import { APP_BASE_HREF } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PagesModule } from './pages/pages.module';
import { GlobalState } from './global.state';
import { NgaModule } from './theme/nga.module';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { Ng2CompleterModule } from 'ng2-completer';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MyDatePickerModule } from 'mydatepicker';
import { NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';

import { Ng2DeviceService } from 'ng2-device-detector';

import { MdDialogModule } from '@angular/material';
import { MdTooltipModule } from '@angular/material';
import { MdSelectModule } from '@angular/material';
import { MdMenuModule } from '@angular/material';
import { MdProgressSpinnerModule } from '@angular/material';
import { MdSliderModule } from '@angular/material';
import { MdCheckboxModule } from '@angular/material';
import { MdExpansionModule } from '@angular/material';
import { MdProgressBarModule } from '@angular/material';
// import { MdTabGroup } from '@angular/material';

// services
// import { LoginService } from './service/login/login.service';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { ReportService } from './services/report.service';
import { HttpAuth } from './services/http-auth.service';
import { JobOffersService } from './services/job-offers.service';
import { HvRecommendedService } from './services/hv-recommended.service';
import { ReportJobService } from './services/report-job.service';
import { FullProfileService } from './services/full-profile.service';
import { LanguageNameService } from './services/language-name.service';
import { LanguageLevelService } from './services/language-level.service';
import { SignupService } from './services/signup.service';
import { UserService } from './services/user.service';
import { VenueService } from './services/venue.service';
import { CandidateService } from './services/candidate.service';
import { EducationLevelService } from './services/educationlevel.service';
import { ContractTypeService } from './services/contracttype.service';
import { JobTypeService } from './services/jobtype.service';
import { EnterpriseService } from './services/enterprise.service';
import { RecoverPasswordService } from './services/recover-password.service';
import { ApplicantService } from './services/applicant.service';
import { JobCategoriesService } from './services/job-categories.service';
import { ListCandidatesService } from './services/list-candidates.service';
import { DocListAnswerService } from './services/doc-list-answer.service';
import { GenderService } from './services/gender.service';
import { TimeZoneService } from './services/timezone.service';
import { FormCompetenceService } from './services/form-competence.service';
import { FormService } from './services/form.service';
import { ColorEventService } from './services/color-event.service';
import { FilesService } from './services/files.service';
import { ApplyStatusService } from './services/apply-status.service';
import { InviteService } from './services/invite.service';
import { AnnotationService } from './services/annotation.service';
import { MessagingService } from './services/messaging.service';
import { ApplyService } from './services/apply.service';
import { NotificationService } from './services/notification.service';
import { TypeEventService } from './services/type-event.service';
import { EventService } from './services/event.service';
import { ReminderService } from './services/reminder.service';
import { PaymentService } from './services/payment.service';
import { ConfigurationService } from './services/configuration.service';

import { OfferStore } from './pages/state/offer.store';
import { ProfileStore } from './pages/state/profile.store';
import { ProfileNoLocationStore } from './pages/state/profile-no-location.store';
import { KanbanOfferStore } from './pages/state/kanban-offer.store';
import { KanbanOfferStoreList } from './pages/state/kanban-offer-list.store';

import { ConfirmationService } from 'primeng/primeng';
export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp( new AuthConfig({}), http, options);
}

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslatePoHttpLoader } from '@biesbjerg/ngx-translate-po-http-loader';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { KanbanOfferContractStore } from './pages/state/kanban-offer-contract.store';
import { PollService } from './services/poll.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { TourNgxBootstrapModule } from 'ngx-tour-ngx-bootstrap';
// import { TourNgxPopperModule } from 'ngx-tour-ngx-popper';
// import { NgxPopperModule } from 'ngx-popper';




export function createTranslateLoader(http: Http) {
  return new TranslatePoHttpLoader(http, '/assets/i18n/', '.po');
}

@NgModule({
  declarations: [
    AppComponent,

  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    PagesModule,
    NgaModule.forRoot(),
    StoreDevtoolsModule.instrument({
      maxAge: 10 // number of states to retain
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [Http]
      }
    }),
    InfiniteScrollModule,
    MdDialogModule,
    MdTooltipModule,
    MdSelectModule,
    MdCheckboxModule,
    MdExpansionModule,
    MdMenuModule,
    MdProgressSpinnerModule,
    MdSliderModule,
    MdProgressBarModule,
    // NgxPopperModule,
    Ng2CompleterModule,
    NgbModule.forRoot(),
    MyDatePickerModule,
    NgbDatepickerModule.forRoot(),
    NgbTimepickerModule.forRoot(),
    TourNgxBootstrapModule.forRoot(),
    //TourNgxPopperModule.forRoot(),
  ],
  providers: [
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [ Http, RequestOptions ]
    },
    { provide: APP_BASE_HREF, useValue: '/' },
    GlobalState,
    Ng2DeviceService,
    ConfirmationService,
    AuthGuardService,
    AuthService,
    HttpAuth,
    WalletService,
    NotificationService,
    AuthGuardService,
    AuthService,
    ReportService,
    ReportPerformService,
    HttpAuth,
    CompanyService,
    JobOffersService,
    HvRecommendedService,
    ReportJobService,
    FullProfileService,
    LanguageNameService,
    InvitePollService,
    InvitePerformService,
    PerformService,
    LanguageLevelService,
    SignupService,
    UserService,
    VenueService,
    CandidateService,
    PollPdfService,
    EducationLevelService,
    ContractTypeService,
    JobTypeService,
    EnterpriseService,
    RecoverPasswordService,
    ApplicantService,
    JobCategoriesService,
    ListCandidatesService,
    DocListAnswerService,
    GenderService,
    TimeZoneService,
    FormCompetenceService,
    FormService,
    ColorEventService,
    FilesService,
    ApplyStatusService,
    InviteService,
    AnnotationService,
    MessagingService,
    ApplyService,
    NotificationService,
    TypeEventService,
    EventService,
    ReminderService,
    PaymentService,
    PollService,
    ConfigurationService,
    { provide: 'KanbanStoreReq', useClass: KanbanOfferStore },
    { provide: 'KanbanStoreNotReq', useClass: KanbanOfferStore },
    { provide: 'KanbanStorePreSel', useClass: KanbanOfferStore },
    { provide: 'KanbanStoreReject', useClass: KanbanOfferStore },
    { provide: 'KanbanStoreHired', useClass: KanbanOfferStore },
    { provide: 'KanbanStoreArray', useClass: KanbanOfferStore },
    OfferStore,
    ProfileStore,
    ProfileNoLocationStore,
    KanbanOfferStore,
    KanbanOfferContractStore,
    KanbanOfferStoreList,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/app.module.ts